module.exports = __webpack_public_path__ + "static/logo-espiral-meiquer-3a6d6b5f7230695b4511d098698f76c1.svg";